<script setup lang="ts">
import CiReviewWrapper from '@/components/CiReview/CiReviewWrapper.vue';

definePageMeta({
  layout: 'default',
  middleware: ['numeric-redirect'],
});
</script>

<template>
  <CiReviewWrapper />
</template>
